import { render } from "./SupplierType.vue?vue&type=template&id=28ad77d4&scoped=true"
import script from "./SupplierType.vue?vue&type=script&lang=js"
export * from "./SupplierType.vue?vue&type=script&lang=js"

import "./SupplierType.vue?vue&type=style&index=0&id=28ad77d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ad77d4"]])

export default __exports__